import { FormattedMessage, useIntl } from 'react-intl';

import UserName from '~/components/Client/UserName';
import { Chip } from '~/eds/src/components/Chip/Chip';
import { DateText } from '~/eds/src/components/DateText/DateText';
import { Icon } from '~/eds/src/components/Icon/Icon';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { FILE_ICONS } from '~/eds/src/constants/file';
import { getFileExtension } from '~/eds/src/utils/getFileExtension';
import { formatFileSize } from '~/utils/files';

interface Props {
  name: string;
  size?: number;
  uploadedBy?: number;
  uploadDate?: string;
  version?: number;
  onRemove: () => void;
}

const OutboundAttachment = ({
  name,
  size,
  uploadedBy,
  uploadDate,
  version,
  onRemove,
}: Props) => {
  const intl = useIntl();

  const extension = getFileExtension(name);
  const fileIcon = FILE_ICONS[extension] || 'file';

  return (
    <Layout align="center" justify="space-between" py={2} px={4} spacing={3}>
      <Layout align="center" spacing={3}>
        <Icon icon={fileIcon} size="m" />
        <Layout direction="column">
          <Text>{name}</Text>
          <Layout align="center">
            {uploadedBy && (
              <Text variant="tiny" color="text.secondary">
                <FormattedMessage
                  id="OutboundAttachment.uploadedBy"
                  defaultMessage="Uploaded by"
                  description="Shows who uploaded the file"
                />{' '}
                <UserName userId={uploadedBy} />{' '}
              </Text>
            )}
            {uploadDate && (
              <Text variant="tiny" color="text.secondary">
                <DateText
                  variant="tiny"
                  date={uploadDate ? new Date(uploadDate) : undefined}
                />
                {' • '}
              </Text>
            )}
            {size && (
              <Text variant="tiny" color="text.secondary">
                {formatFileSize(size)}
              </Text>
            )}
          </Layout>
        </Layout>
      </Layout>
      <Layout align="center" spacing={2}>
        {version && (
          <Chip
            status="info"
            text={intl.formatMessage(
              {
                id: 'OutboundAttachment.versionLabel',
                defaultMessage: 'Version {version}',
                description:
                  "Version label for attachment. Example: version = 'v1.2'",
              },
              { version },
            )}
          />
        )}
        <IconButton
          icon="trash"
          size="s"
          tooltip={intl.formatMessage({
            id: 'OutboundAttachment.removeTitle',
            defaultMessage: 'Remove',
            description: 'Tooltip for remove attachment button',
          })}
          onClick={onRemove}
        />
      </Layout>
    </Layout>
  );
};

export default OutboundAttachment;
